module.exports = __webpack_public_path__ + "855d01ce28a3cfb1bf679eb56d394e74.svg";